import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import columns from './components/Columns';
import MatTable from '../../shared/components/material-table';
import GraphQL from '../../GraphQL';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';

const Shift = (props) => {
  const { dispatch, t, history } = props;

  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  const toggleModal = () => {
    setModal(!modal);
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadData = () => {
    showLoading();
    const dataQuery = '{analysisItemListAll{id, name, order, active}}';
    GraphQL(dataQuery, {})
      .then((res) => {
        let analysisItemList = res.analysisItemListAll;
        analysisItemList = analysisItemList.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        setData(analysisItemList);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const addItemClickHandler = () => {
    let newOrder = 0;
    if (data[data.length - 1]) {
      newOrder = data[data.length - 1].order + 1;
    }
    setSelectedDto({ active: true, id: 0, order: newOrder });
    history.push('/minime/item-analise/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    history.push(`/minime/item-analise/mnt/${rowData.id}`);
  };

  const removeItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    toggleModal();
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeQuery = `mutation {analysisItemRemove(id: ${selectedDto.id})}`;
    GraphQL(removeQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        loadData();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    onRefreshClick={loadData}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    title={t('panels.item-analise')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Shift.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Shift)
);
